export const moonquakes = [
  {
  lat: -3.01084,
  lng: -23.42456,
  date: "19-11-1969",
  year: 1969
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "19-11-1969",
  year: 1969
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "19-11-1969",
  year: 1969
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "19-11-1969",
  year: 1969
  },
  {
  lat: -3.01084,
  lng: -23.42456,
  date: "19-11-1969",
  year: 1969
  },
  {
  lat: -3.01084,
  lng: -23.42456,
  date: "19-11-1969",
  year: 1969
  },
  {
  lat: -3.01084,
  lng: -23.42456,
  date: "19-11-1969",
  year: 1969
  },
  {
  lat: -3.01084,
  lng: -23.42456,
  date: "19-11-1969",
  year: 1969
  },
  {
  lat: -3.01084,
  lng: -23.42456,
  date: "19-11-1969",
  year: 1969
  },
  {
  lat: -3.01084,
  lng: -23.42456,
  date: "19-11-1969",
  year: 1969
  },
  {
  lat: -3.6445,
  lng: -17.47753,
  date: "05-02-1971",
  year: 1971
  },
  {
  lat: -3.65,
  lng: -17.48,
  date: "05-02-1971",
  year: 1971
  },
  {
  lat: -3.65,
  lng: -17.48,
  date: "05-02-1971",
  year: 1971
  },
  {
  lat: -3.65,
  lng: -17.48,
  date: "05-02-1971",
  year: 1971
  },
  {
  lat: -3.6445,
  lng: -17.47753,
  date: "05-02-1971",
  year: 1971
  },
  {
  lat: -3.6445,
  lng: -17.47753,
  date: "05-02-1971",
  year: 1971
  },
  {
  lat: -3.6445,
  lng: -17.47753,
  date: "05-02-1971",
  year: 1971
  },
  {
  lat: -3.6445,
  lng: -17.47753,
  date: "05-02-1971",
  year: 1971
  },
  {
  lat: -3.6445,
  lng: -17.47753,
  date: "05-02-1971",
  year: 1971
  },
  {
  lat: -3.6445,
  lng: -17.47753,
  date: "05-02-1971",
  year: 1971
  },
  {
  lat: -8.97577,
  lng: 15.49649,
  date: "21-04-1972",
  year: 1972
  },
  {
  lat: -8.97,
  lng: 15.51,
  date: "21-04-1972",
  year: 1972
  },
  {
  lat: -8.97,
  lng: 15.51,
  date: "21-04-1972",
  year: 1972
  },
  {
  lat: -8.97,
  lng: 15.51,
  date: "21-04-1972",
  year: 1972
  },
  {
  lat: -8.97577,
  lng: 15.49649,
  date: "21-04-1972",
  year: 1972
  },
  {
  lat: -8.97577,
  lng: 15.49649,
  date: "21-04-1972",
  year: 1972
  },
  {
  lat: -8.97577,
  lng: 15.49649,
  date: "21-04-1972",
  year: 1972
  },
  {
  lat: -8.97577,
  lng: 15.49649,
  date: "21-04-1972",
  year: 1972
  },
  {
  lat: -8.97577,
  lng: 15.49649,
  date: "21-04-1972",
  year: 1972
  },
  {
  lat: -8.97577,
  lng: 15.49649,
  date: "21-04-1972",
  year: 1972
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "16-10-1974",
  year: 1974
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "16-10-1974",
  year: 1974
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "16-10-1974",
  year: 1974
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "09-04-1975",
  year: 1975
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "28-06-1975",
  year: 1975
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "09-04-1975",
  year: 1975
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "28-06-1975",
  year: 1975
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "09-04-1975",
  year: 1975
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "28-06-1975",
  year: 1975
  },
  {
  lat: 26.08,
  lng: 3.66,
  date: "28-06-1975",
  year: 1975
  },
  {
  lat: 26.08,
  lng: 3.66,
  date: "28-06-1975",
  year: 1975
  },
  {
  lat: 26.08,
  lng: 3.66,
  date: "28-06-1975",
  year: 1975
  },
  {
  lat: -8.97,
  lng: 15.51,
  date: "29-06-1975",
  year: 1975
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "27-03-1977",
  year: 1977
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "27-03-1977",
  year: 1977
  },
  {
  lat: -3.04,
  lng: -23.42,
  date: "27-03-1977",
  year: 1977
  },
  {
  lat: 26.08,
  lng: 3.66,
  date: "27-03-1977",
  year: 1977
  },
  {
  lat: 26.08,
  lng: 3.66,
  date: "27-03-1977",
  year: 1977
  },
  {
  lat: 26.08,
  lng: 3.66,
  date: "27-03-1977",
  year: 1977
  },
  {
  lat: -8.97,
  lng: 15.51,
  date: "26-03-1977",
  year: 1977
  },
  {
  lat: -8.97,
  lng: 15.51,
  date: "26-03-1977",
  year: 1977
  },
  {
  lat: -8.97,
  lng: 15.51,
  date: "26-03-1977",
  year: 1977
  },
  {
  lat: -31.604,
  lng: -68.066803,
  date: "25-08-1987",
  year: 1987
  },
  {
  lat: -31.604,
  lng: -68.066803,
  date: "25-08-1987",
  year: 1987
  },
  {
  lat: -31.604,
  lng: -68.066803,
  date: "25-08-1987",
  year: 1987
  },
  {
  lat: -31.604,
  lng: -68.066803,
  date: "25-08-1987",
  year: 1987
  },
  {
  lat: -31.604,
  lng: -68.066803,
  date: "25-08-1987",
  year: 1987
  },
  {
  lat: -31.604,
  lng: -68.066803,
  date: "25-08-1987",
  year: 1987
  },
  {
  lat: -31.6049,
  lng: -68.0662,
  date: "25-08-1987",
  year: 1987
  },
  {
  lat: -31.6049,
  lng: -68.0662,
  date: "25-08-1987",
  year: 1987
  },
  {
  lat: -31.6049,
  lng: -68.0662,
  date: "25-08-1987",
  year: 1987
  },
  {
  lat: -31.6049,
  lng: -68.0662,
  date: "25-08-1987",
  year: 1987
  },
  {
  lat: -31.321501,
  lng: -68.1278,
  date: "26-02-1988",
  year: 1988
  },
  {
  lat: -31.321501,
  lng: -68.1278,
  date: "26-02-1988",
  year: 1988
  },
  {
  lat: -31.321501,
  lng: -68.1278,
  date: "26-02-1988",
  year: 1988
  },
  {
  lat: -31.321501,
  lng: -68.1278,
  date: "26-02-1988",
  year: 1988
  },
  {
  lat: -31.321501,
  lng: -68.1278,
  date: "26-02-1988",
  year: 1988
  },
  {
  lat: -31.321501,
  lng: -68.1278,
  date: "26-02-1988",
  year: 1988
  },
  {
  lat: -31.527599,
  lng: -68.060799,
  date: "29-02-1988",
  year: 1988
  },
  {
  lat: -31.527599,
  lng: -68.060799,
  date: "29-02-1988",
  year: 1988
  },
  {
  lat: -31.527599,
  lng: -68.060799,
  date: "29-02-1988",
  year: 1988
  },
  {
  lat: -31.527599,
  lng: -68.060799,
  date: "29-02-1988",
  year: 1988
  },
  {
  lat: 33.6117,
  lng: -116.4599,
  date: "17-04-1990",
  year: 1990
  },
  {
  lat: 33.6117,
  lng: -116.4599,
  date: "15-05-1990",
  year: 1990
  },
  {
  lat: 33.6117,
  lng: -116.4599,
  date: "17-04-1990",
  year: 1990
  },
  {
  lat: 33.6117,
  lng: -116.4599,
  date: "15-05-1990",
  year: 1990
  },
  {
  lat: 33.611698,
  lng: -116.459297,
  date: "17-04-1990",
  year: 1990
  },
  {
  lat: 33.611698,
  lng: -116.459297,
  date: "15-05-1990",
  year: 1990
  },
  {
  lat: 33.611698,
  lng: -116.459297,
  date: "17-04-1990",
  year: 1990
  },
  {
  lat: 33.611698,
  lng: -116.459297,
  date: "15-05-1990",
  year: 1990
  },
  {
  lat: 33.6117,
  lng: -116.4599,
  date: "17-04-1990",
  year: 1990
  },
  {
  lat: 33.6117,
  lng: -116.4599,
  date: "15-05-1990",
  year: 1990
  },
  {
  lat: 33.606499,
  lng: -116.453102,
  date: "01-02-1991",
  year: 1991
  },
  {
  lat: 33.606499,
  lng: -116.453102,
  date: "03-03-1991",
  year: 1991
  },
  {
  lat: 33.606499,
  lng: -116.453102,
  date: "20-03-1991",
  year: 1991
  },
  {
  lat: 33.606499,
  lng: -116.453102,
  date: "20-03-1991",
  year: 1991
  },
  {
  lat: 33.606499,
  lng: -116.453102,
  date: "01-02-1991",
  year: 1991
  },
  {
  lat: 33.606499,
  lng: -116.453102,
  date: "03-03-1991",
  year: 1991
  },
  {
  lat: 33.606499,
  lng: -116.453102,
  date: "20-03-1991",
  year: 1991
  },
  {
  lat: 33.606499,
  lng: -116.453102,
  date: "20-03-1991",
  year: 1991
  },
  {
  lat: 33.606499,
  lng: -116.453102,
  date: "01-02-1991",
  year: 1991
  },
  {
  lat: 33.606499,
  lng: -116.453102,
  date: "03-03-1991",
  year: 1991
  },
  {
  lat: 33.931999,
  lng: -116.380203,
  date: "25-04-1992",
  year: 1992
  },
  {
  lat: 33.931999,
  lng: -116.380203,
  date: "25-04-1992",
  year: 1992
  },
  {
  lat: 33.931999,
  lng: -116.380203,
  date: "25-04-1992",
  year: 1992
  },
  {
  lat: 33.931999,
  lng: -116.380203,
  date: "25-04-1992",
  year: 1992
  },
  {
  lat: 33.931999,
  lng: -116.380203,
  date: "25-04-1992",
  year: 1992
  },
  {
  lat: 33.931999,
  lng: -116.380203,
  date: "25-04-1992",
  year: 1992
  },
  {
  lat: 34.069,
  lng: -116.392303,
  date: "25-04-1992",
  year: 1992
  },
  {
  lat: 34.069,
  lng: -116.392303,
  date: "25-04-1992",
  year: 1992
  },
  {
  lat: 34.069,
  lng: -116.392303,
  date: "25-04-1992",
  year: 1992
  },
  {
  lat: 34.069,
  lng: -116.392303,
  date: "25-04-1992",
  year: 1992
  },
  {
  lat: 37.042999,
  lng: -113.127998,
  date: "19-09-1993",
  year: 1993
  },
  {
  lat: 37.042999,
  lng: -113.127998,
  date: "19-09-1993",
  year: 1993
  },
  {
  lat: 37.042999,
  lng: -113.127998,
  date: "19-09-1993",
  year: 1993
  },
  {
  lat: 37.042999,
  lng: -113.127998,
  date: "20-09-1993",
  year: 1993
  },
  {
  lat: 37.036999,
  lng: -113.313004,
  date: "19-09-1993",
  year: 1993
  },
  {
  lat: 37.036999,
  lng: -113.313004,
  date: "19-09-1993",
  year: 1993
  },
  {
  lat: 37.036999,
  lng: -113.313004,
  date: "19-09-1993",
  year: 1993
  },
  {
  lat: 37.036999,
  lng: -113.313004,
  date: "20-09-1993",
  year: 1993
  },
  {
  lat: 37.036999,
  lng: -113.313004,
  date: "22-09-1993",
  year: 1993
  },
  {
  lat: 37.027,
  lng: -113.575996,
  date: "19-09-1993",
  year: 1993
  },
  {
  lat: 34.2337,
  lng: -118.545502,
  date: "09-02-1994",
  year: 1994
  },
  {
  lat: 34.2337,
  lng: -118.545502,
  date: "09-02-1994",
  year: 1994
  },
  {
  lat: 34.2337,
  lng: -118.545502,
  date: "09-02-1994",
  year: 1994
  },
  {
  lat: 34.2337,
  lng: -118.545502,
  date: "09-02-1994",
  year: 1994
  },
  {
  lat: 34.2337,
  lng: -118.545502,
  date: "09-02-1994",
  year: 1994
  },
  {
  lat: 34.2337,
  lng: -118.545502,
  date: "09-02-1994",
  year: 1994
  },
  {
  lat: 34.2024,
  lng: -118.698601,
  date: "25-01-1994",
  year: 1994
  },
  {
  lat: 34.2024,
  lng: -118.698601,
  date: "25-01-1994",
  year: 1994
  },
  {
  lat: 34.2024,
  lng: -118.698601,
  date: "25-01-1994",
  year: 1994
  },
  {
  lat: 34.2024,
  lng: -118.698601,
  date: "25-01-1994",
  year: 1994
  },
  {
  lat: 42.317501,
  lng: -72.7117,
  date: "08-02-1995",
  year: 1995
  },
  {
  lat: 42.317501,
  lng: -72.7117,
  date: "08-02-1995",
  year: 1995
  },
  {
  lat: 42.317501,
  lng: -72.7117,
  date: "08-02-1995",
  year: 1995
  },
  {
  lat: 42.317501,
  lng: -72.7117,
  date: "08-02-1995",
  year: 1995
  },
  {
  lat: 42.317501,
  lng: -72.7117,
  date: "08-02-1995",
  year: 1995
  },
  {
  lat: 42.317501,
  lng: -72.7117,
  date: "08-02-1995",
  year: 1995
  },
  {
  lat: 42.317501,
  lng: -72.7117,
  date: "08-02-1995",
  year: 1995
  },
  {
  lat: 42.166,
  lng: -73.718697,
  date: "04-02-1995",
  year: 1995
  },
  {
  lat: 42.166,
  lng: -73.718697,
  date: "04-02-1995",
  year: 1995
  },
  {
  lat: 42.166,
  lng: -73.718697,
  date: "04-02-1995",
  year: 1995
  },
  {
  lat: 42.038799,
  lng: -74.846191,
  date: "27-01-1996",
  year: 1996
  },
  {
  lat: 42.038799,
  lng: -74.846191,
  date: "27-01-1996",
  year: 1996
  },
  {
  lat: 42.038799,
  lng: -74.846191,
  date: "27-01-1996",
  year: 1996
  },
  {
  lat: 42.038799,
  lng: -74.846191,
  date: "27-01-1996",
  year: 1996
  },
  {
  lat: 42.038799,
  lng: -74.846191,
  date: "27-01-1996",
  year: 1996
  },
  {
  lat: 42.038799,
  lng: -74.846191,
  date: "27-01-1996",
  year: 1996
  },
  {
  lat: 41.853001,
  lng: -76.19799,
  date: "18-01-1996",
  year: 1996
  },
  {
  lat: 41.853001,
  lng: -76.19799,
  date: "18-01-1996",
  year: 1996
  },
  {
  lat: 41.853001,
  lng: -76.19799,
  date: "18-01-1996",
  year: 1996
  },
  {
  lat: 41.853001,
  lng: -76.19799,
  date: "18-01-1996",
  year: 1996
  },
  {
  lat: -34.294456,
  lng: 19.245951,
  date: "12-05-1997",
  year: 1997
  },
  {
  lat: -34.294456,
  lng: 19.245951,
  date: "20-08-1997",
  year: 1997
  },
  {
  lat: -34.294456,
  lng: 19.245951,
  date: "12-05-1997",
  year: 1997
  },
  {
  lat: -34.294456,
  lng: 19.245951,
  date: "20-08-1997",
  year: 1997
  },
  {
  lat: -34.294456,
  lng: 19.245951,
  date: "12-05-1997",
  year: 1997
  },
  {
  lat: -34.294456,
  lng: 19.245951,
  date: "20-08-1997",
  year: 1997
  },
  {
  lat: -34.294456,
  lng: 19.245951,
  date: "12-05-1997",
  year: 1997
  },
  {
  lat: -31.977606,
  lng: 20.2262,
  date: "07-05-1997",
  year: 1997
  },
  {
  lat: -31.977606,
  lng: 20.2262,
  date: "07-05-1997",
  year: 1997
  },
  {
  lat: -31.977606,
  lng: 20.2262,
  date: "07-05-1997",
  year: 1997
  },
  {
  lat: -34.294456,
  lng: 19.245951,
  date: "25-02-1998",
  year: 1998
  },
  {
  lat: -34.294456,
  lng: 19.245951,
  date: "25-06-1998",
  year: 1998
  },
  {
  lat: -34.294456,
  lng: 19.245951,
  date: "25-02-1998",
  year: 1998
  },
  {
  lat: -34.294456,
  lng: 19.245951,
  date: "25-06-1998",
  year: 1998
  },
  {
  lat: -34.294456,
  lng: 19.245951,
  date: "25-02-1998",
  year: 1998
  },
  {
  lat: -34.294456,
  lng: 19.245951,
  date: "25-06-1998",
  year: 1998
  },
  {
  lat: -33.7351,
  lng: 20.2663,
  date: "03-07-1998",
  year: 1998
  },
  {
  lat: -33.7351,
  lng: 20.2663,
  date: "09-07-1998",
  year: 1998
  },
  {
  lat: -33.7351,
  lng: 20.2663,
  date: "03-07-1998",
  year: 1998
  },
  {
  lat: -33.7351,
  lng: 20.2663,
  date: "09-07-1998",
  year: 1998
  },
  {
  lat: -28.632814,
  lng: 24.305628,
  date: "12-04-1999",
  year: 1999
  },
  {
  lat: -28.632814,
  lng: 24.305628,
  date: "12-04-1999",
  year: 1999
  },
  {
  lat: -28.632814,
  lng: 24.305628,
  date: "12-04-1999",
  year: 1999
  },
  {
  lat: -28.632814,
  lng: 24.305628,
  date: "12-04-1999",
  year: 1999
  },
  {
  lat: -28.632814,
  lng: 24.305628,
  date: "12-04-1999",
  year: 1999
  },
  {
  lat: -28.632814,
  lng: 24.305628,
  date: "12-04-1999",
  year: 1999
  },
  {
  lat: -28.9056,
  lng: 24.8328,
  date: "11-04-1999",
  year: 1999
  },
  {
  lat: -28.9056,
  lng: 24.8328,
  date: "11-04-1999",
  year: 1999
  },
  {
  lat: -28.9056,
  lng: 24.8328,
  date: "11-04-1999",
  year: 1999
  },
  {
  lat: -28.9056,
  lng: 24.8328,
  date: "11-04-1999",
  year: 1999
  },
  {
  lat: 27.547701,
  lng: 90.766403,
  date: "15-01-2002",
  year: 2002
  },
  {
  lat: 27.547701,
  lng: 90.766403,
  date: "15-01-2002",
  year: 2002
  },
  {
  lat: 27.547701,
  lng: 90.766403,
  date: "15-01-2002",
  year: 2002
  },
  {
  lat: 27.547701,
  lng: 90.766403,
  date: "15-01-2002",
  year: 2002
  },
  {
  lat: 27.082701,
  lng: 89.550301,
  date: "13-01-2002",
  year: 2002
  },
  {
  lat: 27.082701,
  lng: 89.550301,
  date: "13-01-2002",
  year: 2002
  },
  {
  lat: 27.082701,
  lng: 89.550301,
  date: "13-01-2002",
  year: 2002
  },
  {
  lat: 27.082701,
  lng: 89.550301,
  date: "13-01-2002",
  year: 2002
  },
  {
  lat: 27.492201,
  lng: 89.643501,
  date: "22-01-2002",
  year: 2002
  },
  {
  lat: 27.492201,
  lng: 89.643501,
  date: "22-01-2002",
  year: 2002
  },
  {
  lat: -77.722397,
  lng: 162.273499,
  date: "29-10-2004",
  year: 2004
  },
  {
  lat: -77.722397,
  lng: 162.273499,
  date: "29-10-2004",
  year: 2004
  },
  {
  lat: -77.722397,
  lng: 162.273499,
  date: "29-10-2004",
  year: 2004
  },
  {
  lat: -77.722397,
  lng: 162.273499,
  date: "29-10-2004",
  year: 2004
  },
  {
  lat: -77.722397,
  lng: 162.273499,
  date: "29-10-2004",
  year: 2004
  },
  {
  lat: -77.722397,
  lng: 162.273499,
  date: "29-10-2004",
  year: 2004
  },
  {
  lat: -77.722397,
  lng: 162.273499,
  date: "29-10-2004",
  year: 2004
  },
  {
  lat: -77.722397,
  lng: 162.273499,
  date: "29-10-2004",
  year: 2004
  },
  {
  lat: -77.722397,
  lng: 162.273499,
  date: "29-10-2004",
  year: 2004
  },
  {
  lat: -77.722397,
  lng: 162.273499,
  date: "29-10-2004",
  year: 2004
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "27-06-2008",
  year: 2008
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "02-12-2008",
  year: 2008
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "27-06-2008",
  year: 2008
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "02-12-2008",
  year: 2008
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "27-06-2008",
  year: 2008
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "02-12-2008",
  year: 2008
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "06-05-2008",
  year: 2008
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "27-06-2008",
  year: 2008
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "02-12-2008",
  year: 2008
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "06-05-2008",
  year: 2008
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "15-09-2009",
  year: 2009
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "15-09-2009",
  year: 2009
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "15-09-2009",
  year: 2009
  },
  {
  lat: 44.3377,
  lng: -123.407402,
  date: "15-09-2009",
  year: 2009
  },
  {
  lat: 44.003502,
  lng: -123.829803,
  date: "15-09-2009",
  year: 2009
  },
  {
  lat: 44.003502,
  lng: -123.829803,
  date: "15-09-2009",
  year: 2009
  },
  {
  lat: 44.003502,
  lng: -123.829803,
  date: "15-09-2009",
  year: 2009
  },
  {
  lat: 44.676399,
  lng: -123.999702,
  date: "15-09-2009",
  year: 2009
  },
  {
  lat: 44.676399,
  lng: -123.999702,
  date: "15-09-2009",
  year: 2009
  },
  {
  lat: 44.676399,
  lng: -123.999702,
  date: "15-09-2009",
  year: 2009
  },
  {
  lat: 30.996053,
  lng: -3.966859,
  date: "03-05-2010",
  year: 2010
  },
  {
  lat: 30.998397,
  lng: -3.971314,
  date: "03-05-2010",
  year: 2010
  },
  {
  lat: 31.003853,
  lng: -3.973672,
  date: "03-05-2010",
  year: 2010
  },
  {
  lat: 31.008728,
  lng: -3.976134,
  date: "03-05-2010",
  year: 2010
  },
  {
  lat: 31.013676,
  lng: -3.979064,
  date: "03-05-2010",
  year: 2010
  },
  {
  lat: 31.016795,
  lng: -3.980405,
  date: "03-05-2010",
  year: 2010
  },
  {
  lat: 31.019615,
  lng: -3.985183,
  date: "03-05-2010",
  year: 2010
  },
  {
  lat: 31.022755,
  lng: -3.998117,
  date: "03-05-2010",
  year: 2010
  },
  {
  lat: 31.027139,
  lng: -4.004218,
  date: "03-05-2010",
  year: 2010
  },
  {
  lat: 31.031469,
  lng: -4.005196,
  date: "03-05-2010",
  year: 2010
  },
  {
  lat: -43.5798,
  lng: 172.595596,
  date: "05-05-2011",
  year: 2011
  },
  {
  lat: -43.5798,
  lng: 172.595596,
  date: "05-05-2011",
  year: 2011
  },
  {
  lat: -43.5798,
  lng: 172.595596,
  date: "05-05-2011",
  year: 2011
  },
  {
  lat: -43.5798,
  lng: 172.595596,
  date: "05-05-2011",
  year: 2011
  },
  {
  lat: -43.580799,
  lng: 172.595398,
  date: "05-05-2011",
  year: 2011
  },
  {
  lat: -43.580799,
  lng: 172.595398,
  date: "05-05-2011",
  year: 2011
  },
  {
  lat: -43.580799,
  lng: 172.595398,
  date: "05-05-2011",
  year: 2011
  },
  {
  lat: -43.580799,
  lng: 172.595398,
  date: "05-05-2011",
  year: 2011
  },
  {
  lat: -43.581001,
  lng: 172.595398,
  date: "05-05-2011",
  year: 2011
  },
  {
  lat: -43.581001,
  lng: 172.595398,
  date: "05-05-2011",
  year: 2011
  },
  {
  lat: 43.67001,
  lng: -70.80329,
  date: "19-10-2012",
  year: 2012
  },
  {
  lat: 43.64281,
  lng: -70.88645,
  date: "19-10-2012",
  year: 2012
  },
  {
  lat: 43.58141,
  lng: -70.87186,
  date: "19-10-2012",
  year: 2012
  },
  {
  lat: 43.50629,
  lng: -70.81506,
  date: "19-10-2012",
  year: 2012
  },
  {
  lat: 43.45831,
  lng: -70.76268,
  date: "19-10-2012",
  year: 2012
  },
  {
  lat: 43.61083,
  lng: -70.76068,
  date: "19-10-2012",
  year: 2012
  },
  {
  lat: 43.53117,
  lng: -70.65152,
  date: "19-10-2012",
  year: 2012
  },
  {
  lat: 43.47749,
  lng: -70.57361,
  date: "19-10-2012",
  year: 2012
  },
  {
  lat: 43.73645,
  lng: -70.68934,
  date: "19-10-2012",
  year: 2012
  },
  {
  lat: 43.68704,
  lng: -70.61529,
  date: "19-10-2012",
  year: 2012
  },
  {
  lat: 26.80247,
  lng: 91.50078,
  date: "28-01-2013",
  year: 2013
  },
  {
  lat: 26.80247,
  lng: 91.50078,
  date: "28-01-2013",
  year: 2013
  },
  {
  lat: 26.80247,
  lng: 91.50078,
  date: "28-01-2013",
  year: 2013
  },
  {
  lat: 26.86041,
  lng: 91.48093,
  date: "27-01-2013",
  year: 2013
  },
  {
  lat: 26.86041,
  lng: 91.48093,
  date: "27-01-2013",
  year: 2013
  },
  {
  lat: 26.86041,
  lng: 91.48093,
  date: "27-01-2013",
  year: 2013
  },
  {
  lat: 26.92892,
  lng: 91.54247,
  date: "26-01-2013",
  year: 2013
  },
  {
  lat: 26.92892,
  lng: 91.54247,
  date: "26-01-2013",
  year: 2013
  },
  {
  lat: 26.92892,
  lng: 91.54247,
  date: "26-01-2013",
  year: 2013
  },
  {
  lat: 27.00157,
  lng: 91.52583,
  date: "28-01-2013",
  year: 2013
  },
  {
  lat: 27.62811,
  lng: 91.48057,
  date: "05-04-2014",
  year: 2014
  },
  {
  lat: 27.62811,
  lng: 91.48057,
  date: "05-04-2014",
  year: 2014
  },
  {
  lat: 27.62811,
  lng: 91.48057,
  date: "05-04-2014",
  year: 2014
  },
  {
  lat: 27.54427,
  lng: 90.14894,
  date: "12-04-2014",
  year: 2014
  },
  {
  lat: 27.54427,
  lng: 90.14894,
  date: "12-04-2014",
  year: 2014
  },
  {
  lat: 27.54427,
  lng: 90.14894,
  date: "12-04-2014",
  year: 2014
  },
  {
  lat: 27.49917,
  lng: 90.50783,
  date: "02-04-2014",
  year: 2014
  },
  {
  lat: 27.49917,
  lng: 90.50783,
  date: "02-04-2014",
  year: 2014
  },
  {
  lat: 27.49917,
  lng: 90.50783,
  date: "02-04-2014",
  year: 2014
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "21-06-2017",
  year: 2017
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "21-06-2017",
  year: 2017
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "21-06-2017",
  year: 2017
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "21-06-2017",
  year: 2017
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "21-06-2017",
  year: 2017
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "21-06-2017",
  year: 2017
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "21-06-2017",
  year: 2017
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "21-06-2017",
  year: 2017
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "21-06-2017",
  year: 2017
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "21-06-2017",
  year: 2017
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "13-10-2018",
  year: 2018
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "13-10-2018",
  year: 2018
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "13-10-2018",
  year: 2018
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "13-10-2018",
  year: 2018
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "13-10-2018",
  year: 2018
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "13-10-2018",
  year: 2018
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "13-10-2018",
  year: 2018
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "13-10-2018",
  year: 2018
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "13-10-2018",
  year: 2018
  },
  {
  lat: 39.5585,
  lng: 46.0076,
  date: "13-10-2018",
  year: 2018
  },
  {
  lat: 40.1368,
  lng: 48.5392,
  date: "26-09-2019",
  year: 2019
  },
  {
  lat: 40.1368,
  lng: 48.5392,
  date: "26-09-2019",
  year: 2019
  },
  {
  lat: 40.1368,
  lng: 48.5392,
  date: "26-09-2019",
  year: 2019
  },
  {
  lat: 40.1368,
  lng: 48.5392,
  date: "26-09-2019",
  year: 2019
  },
  {
  lat: 40.1368,
  lng: 48.5392,
  date: "26-09-2019",
  year: 2019
  },
  {
  lat: 40.1368,
  lng: 48.5392,
  date: "26-09-2019",
  year: 2019
  },
  {
  lat: 40.1368,
  lng: 48.5392,
  date: "26-09-2019",
  year: 2019
  },
  {
  lat: 40.1368,
  lng: 48.5392,
  date: "26-09-2019",
  year: 2019
  },
  {
  lat: 40.1368,
  lng: 48.5392,
  date: "26-09-2019",
  year: 2019
  },
  {
  lat: 40.1368,
  lng: 48.5392,
  date: "26-09-2019",
  year: 2019
  },
  {
  lat: 42.1828,
  lng: 45.4358,
  date: "06-11-2020",
  year: 2020
  },
  {
  lat: 42.1828,
  lng: 45.4358,
  date: "06-11-2020",
  year: 2020
  },
  {
  lat: 42.1828,
  lng: 45.4358,
  date: "06-11-2020",
  year: 2020
  },
  {
  lat: 42.1828,
  lng: 45.4358,
  date: "06-11-2020",
  year: 2020
  },
  {
  lat: 42.1828,
  lng: 45.4358,
  date: "06-11-2020",
  year: 2020
  },
  {
  lat: 42.1828,
  lng: 45.4358,
  date: "06-11-2020",
  year: 2020
  },
  {
  lat: 42.1828,
  lng: 45.4358,
  date: "06-11-2020",
  year: 2020
  },
  {
  lat: 42.1828,
  lng: 45.4358,
  date: "06-11-2020",
  year: 2020
  },
  {
  lat: 42.1828,
  lng: 45.4358,
  date: "06-11-2020",
  year: 2020
  },
  {
  lat: 42.1828,
  lng: 45.4358,
  date: "06-11-2020",
  year: 2020
  },
  {
  lat: 40.294,
  lng: 43.8291,
  date: "23-09-2021",
  year: 2021
  },
  {
  lat: 40.294,
  lng: 43.8291,
  date: "23-09-2021",
  year: 2021
  },
  {
  lat: 40.294,
  lng: 43.8291,
  date: "23-09-2021",
  year: 2021
  },
  {
  lat: 40.294,
  lng: 43.8291,
  date: "23-09-2021",
  year: 2021
  },
  {
  lat: 40.294,
  lng: 43.8291,
  date: "23-09-2021",
  year: 2021
  },
  {
  lat: 40.294,
  lng: 43.8291,
  date: "23-09-2021",
  year: 2021
  },
  {
  lat: 40.294,
  lng: 43.8291,
  date: "23-09-2021",
  year: 2021
  },
  {
  lat: 40.294,
  lng: 43.8291,
  date: "23-09-2021",
  year: 2021
  },
  {
  lat: 40.294,
  lng: 43.8291,
  date: "23-09-2021",
  year: 2021
  },
  {
  lat: 40.294,
  lng: 43.8291,
  date: "23-09-2021",
  year: 2021
  }
  ]